enum FilterType {
  date
  select
  multiselect
  searchselector
  userinput
}

type FilterOption {
  default: Boolean!
  display: String!
  value: String!
  organisationId: String
  organisationName: String
}

type FilterSchema {
  display_name: String!
  param_name: String!
  type: FilterType!
  values: [FilterOption!]
  values_discovery: String
}

type FilterOptionNew {
  error: String
  name: String
  values: [FilterOption!]
}
